import { Settings } from 'react-slick';

export const carouselSettings: Settings = {
	centerMode: true,
	adaptiveHeight: true,
	infinite: true,
	speed: 500,
	autoplaySpeed: 3000,
	pauseOnFocus: true,
	pauseOnDotsHover: true,
	arrows: true,
	dots: true,
	centerPadding: '0',
	swipeToSlide: true,
};

export const backgroundClassMap = {
	gray: 'gray-bg',
	white: 'white-bg',
	gradient: 'vertical-gradient-bg',
};
